var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShoppingBag = function SvgShoppingBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0a5.25 5.25 0 0 0-5.25 5.25V6H.207l.754 13.648C1.076 22.086 3.111 24 5.5 24h9c2.4 0 4.375-1.925 4.49-4.35L19.796 6H15.25v-.75C15.25 2.35 12.9 0 10 0Zm3.75 7.5v3.75h1.5V7.5h2.954l-.711 12.066v.01c-.077 1.649-1.416 2.924-2.993 2.924h-9c-1.59 0-2.965-1.287-3.04-2.924L1.791 7.5H4.75v3.75h1.5V7.5h7.5Zm0-1.5v-.75a3.75 3.75 0 1 0-7.5 0V6h7.5Z",
    fill: "#000"
  })));
};
export default SvgShoppingBag;